export default "__VITE_ASSET__CTcafRz8__"